/**
 * Short place from a venue string (docs/UX-REDESIGN.md UX-S4).
 *
 * A named venue followed by a postal address keeps the name:
 * "SURF Incubator, 999 Third Ave, …" → "SURF Incubator".
 * A name glued to a street, then the same street again, keeps the name:
 * "Alki Junkyard 3099 63rd Ave SW, Seattle, …, 3099 63rd Ave SW, …" → "Alki Junkyard".
 * "Student Union Building (HUB)" stays. A street with no venue name keeps the
 * street and drops city, state, ZIP, and country. Nothing here invents a
 * neighborhood.
 */
/**
 * Street line for the detail (issue #73). A number plus a street suffix.
 * City, state, ZIP, and country stay off the line. Null when the venue has
 * no street, as with a trail description.
 */
const STREET =
  /\b(\d{1,6}\s+(?:[NSEW]\.?\s+)?[A-Za-z0-9.'-]+(?:\s+[A-Za-z0-9.'-]+){0,3}\s+(?:Ave(?:nue)?|St(?:reet)?|Rd|Road|Blvd|Boulevard|Way|Dr(?:ive)?|Ln|Lane|Pl(?:ace)?|Ct|Court|Pkwy|Parkway|Ter(?:race)?)(?:\s+[NSEW]{1,2})?)\b/;

export function streetAddress(venueName: string | null | undefined): string | null {
  const raw = (venueName ?? '').replace(/\s+/g, ' ').trim();
  const match = STREET.exec(raw);
  return match?.[1]?.replace(/\s+/g, ' ').trim() ?? null;
}

export function shortPlace(venueName: string | null | undefined): string {
  const raw = (venueName ?? '').replace(/\s+/g, ' ').trim();
  if (!raw) return '';
  const head = raw.split(',')[0]?.trim() ?? raw;
  if (/^\d/.test(head)) return head;
  const named = head.replace(/\s+\d{1,6}\s+\S.*$/, '').trim();
  return named || head;
}
